/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthRequestService } from '@services/auth/auth-request.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(private authRequestService: AuthRequestService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authReq = req.clone({
      headers: this.getHeaders(req.url, req.headers)
    });

    return next.handle(authReq);
  }

  private getHeaders(url: string, reqHeaders: HttpHeaders): HttpHeaders {
    return this.authRequestService.applyAuthHeaderOnHeadersWhenNecessary(
      reqHeaders,
      { url }
    );
  }
}
